import {TranslateService} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {NotifyService} from '../notify.service';
import 'rxjs-compat/add/operator/map';

export interface Settings {
  [key: string]: {
    company_id: number;
    data: any[] | any,
  };
}

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  public settings$: ReplaySubject<Settings> = new ReplaySubject(1);
  public settings: Settings = undefined;
  private settingsIsLoading = false;

  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private toast: NotifyService,
  ) {
    this.settings$.subscribe((settings: Settings) => {
      if (settings) {
        this.onSettingsChange(settings);
      }
    });
  }

  private onSettingsChange(settings: Settings) {
    this.toast.debug('settings', settings);
    // set purchase order table delete button show status
  }

  init() {
    this.settings = undefined;
    this.all().subscribe();
  }

  all() {
    if (!this.settingsIsLoading && this.settings === undefined) {
      if (this.settings) {
        // get from cache
        this.settingsIsLoading = false;
      } else {
        // get from api
        this.http
          .get('settings/agent')
          .finally(() => (this.settingsIsLoading = false))
          .map((data: { option_name: string; option_value: string; data: {}; company_id: number; }[]) => {
            let settings = {};
            data.map(item => {
              settings[item.option_name] = {
                data: item.option_value || item.data,
                company_id: item.company_id,
              };
            });
            return settings;
          })
          .subscribe(
            (data: Settings) => {
              this.setSettings(data);
            },
            error =>
              this.toast.show(this.translate.instant('alert_read_settings_failed'))
          );
      }
    }
    return this.settings$;
  }

  setSettings(settings: Settings) {
    this.settings = settings;
    this.publish(this.settings);
  }

  setSetting(key, value) {
    if (this.settings.hasOwnProperty(key)) {
      this.settings[key] = value;
      this.publish(this.settings);
    }
  }

  private publish(settings: Settings) {
    this.settings$.next(settings);
  }

  initTranslation() {
    this.http
    .get('settings/translation/read')
    .subscribe(
      (res: any) => {
        if (res.translation) {
          this.translate.setTranslation('en', res.translation);
          // this.translate.reloadLang('en');
        }
      },
      error =>
        this.toast.show(this.translate.instant('alert_read_settings_failed'))
    );
  }
}
